"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniqueDrivingLicenceNumberValidation = void 0;
const FalconValidationMethodBase_1 = require("./FalconValidationMethodBase");
const InteractionHelper_1 = require("../helpers/InteractionHelper");
/**
 * Validates that driving licence number has not been used for another driver
 */
class UniqueDrivingLicenceNumberValidation extends FalconValidationMethodBase_1.FalconValidationMethodBase {
    constructor(props, commandsExecutor) {
        super(commandsExecutor);
        this.POLICY_HOLDER_DRIVER_INDEX = "policyHolder";
        this.getDlnToValidate = (interaction) => {
            var _a;
            let driver;
            if (this.props.driverIndex === this.POLICY_HOLDER_DRIVER_INDEX) {
                driver = interaction.policyHolder;
            }
            else {
                driver = interaction.additionalDrivers && interaction.additionalDrivers[this.props.driverIndex];
            }
            const dln = (_a = driver === null || driver === void 0 ? void 0 : driver.licence) === null || _a === void 0 ? void 0 : _a.number;
            return dln && dln.replace(/\s+/g, '').toUpperCase();
        };
        this.props = props;
        if (this.props.driverIndex === undefined || this.props.driverIndex === null) {
            throw new Error("Missing setting: 'driverIndex'");
        }
    }
    validateInput(input, context) {
        const interaction = this.getInteraction(context);
        if (!interaction) {
            return this.validResult();
        }
        const dlnToValidate = this.getDlnToValidate(interaction);
        if (!dlnToValidate) {
            return this.validResult();
        }
        const allDrivers = InteractionHelper_1.InteractionHelper.getAllDrivers(interaction);
        const duplicatesOfDlnToValidate = allDrivers
            .map(InteractionHelper_1.InteractionHelper.getDrivingLicenceNumber)
            .filter((dln) => dln === dlnToValidate);
        if (duplicatesOfDlnToValidate.length > 1) {
            return this.invalidResult(this.getErrorMessage(context, "This driving licence number is used for more than one driver"));
        }
        return this.validResult();
    }
}
exports.UniqueDrivingLicenceNumberValidation = UniqueDrivingLicenceNumberValidation;
//# sourceMappingURL=UniqueDrivingLicenceNumberValidation.js.map